import React, { FC } from 'react';
import { Routes as RRRoutes } from 'react-router-dom';
import { RoutesProps } from 'react-router/dist/lib/components';

const Routes: FC<RoutesProps> = (props) => {
	return <RRRoutes {...props} />;
};

export { Routes };
